import { defineStore } from "pinia";
import { TopolSocialBlock, TopolSocialElement } from "types/Template/Index";
import { useMjmlStore } from "./mjmlStore";

interface State {
  availableSocialNetworks: TopolSocialElement[];
}

export const useSocialNetworksStore = defineStore("socialNetworks", {
  state: (): State => ({
    availableSocialNetworks: [
      {
        tagName: "mj-social-element",
        attributes: {
          src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlined/facebook.png",
          name: "facebook-noshare",
          alt: "Facebook",
          href: "https://www.facebook.com/PROFILE",
          "background-color": "transparent",
          show: true,
        },
      },
      {
        tagName: "mj-social-element",
        attributes: {
          src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlined/twitter.png",
          name: "twitter-noshare",
          alt: "Twitter",
          href: "https://www.twitter.com/PROFILE",
          "background-color": "transparent",
          show: true,
        },
      },
      {
        tagName: "mj-social-element",
        attributes: {
          src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlined/linkedin.png",
          name: "linkedin-noshare",
          alt: "LinkedIn",
          href: "https://www.linkedin.com/PROFILE",
          "background-color": "transparent",
          show: true,
        },
      },
      {
        tagName: "mj-social-element",
        attributes: {
          src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlined/instagram.png",
          alt: "Instagram",
          name: "instagram",
          href: "https://www.instagram.com/PROFILE",
          "background-color": "transparent",
          show: true,
        },
      },

      {
        tagName: "mj-social-element",
        attributes: {
          src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlined/x.png",
          alt: "X",
          name: "x-noshare",
          href: "https://www.x.com/PROFILE",
          "background-color": "transparent",
          show: false,
        },
      },
      {
        tagName: "mj-social-element",
        attributes: {
          src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlined/pinterest.png",
          alt: "Pinterest",
          name: "pinterest",
          href: "",
          "background-color": "transparent",
          show: false,
        },
      },
      {
        tagName: "mj-social-element",
        attributes: {
          src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlined/youtube.png",
          alt: "YouTube",
          name: "youtube",
          href: "",
          "background-color": "transparent",
          show: false,
        },
      },
      {
        tagName: "mj-social-element",
        attributes: {
          src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlined/spotify.png",
          alt: "Spotify",
          name: "spotify",
          href: "",
          "background-color": "transparent",
          show: false,
        },
      },
      {
        tagName: "mj-social-element",
        attributes: {
          src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlined/tiktok.png",
          alt: "TikTok",
          name: "tiktok",
          href: "",
          "background-color": "transparent",
          show: false,
        },
      },
      {
        tagName: "mj-social-element",
        attributes: {
          src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlined/applepod.png",
          alt: "ApplePod",
          name: "applepod",
          href: "",
          "background-color": "transparent",
          show: false,
        },
      },
      {
        tagName: "mj-social-element",
        attributes: {
          src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlined/snapchat.png",
          alt: "Snapchat",
          name: "snapchat",
          href: "",
          "background-color": "transparent",
          show: false,
        },
      },
      {
        tagName: "mj-social-element",
        attributes: {
          src: "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlined/threads.png",
          alt: "Threads",
          name: "Threads",
          href: "",
          "background-color": "transparent",
          show: false,
        },
      },
    ],
  }),

  getters: {
    getSocialNetworks(): TopolSocialElement[] {
      const mjmlStore = useMjmlStore();
      const activeBlock = mjmlStore.getActiveBlock as
        | TopolSocialBlock
        | undefined;

      if (!mjmlStore.selectedBlock || !activeBlock) {
        return [];
      }

      let unusedNetworks: TopolSocialElement[] = this.availableSocialNetworks;

      for (const network of activeBlock.children) {
        if (network && network.attributes) {
          network.attributes.show = true;
          unusedNetworks = unusedNetworks.filter(
            (item) =>
              item.attributes.name.toLowerCase().replace("-noshare", "") !==
              network.attributes.name.toLowerCase().replace("-noshare", "")
          );
        }
      }

      for (const network of unusedNetworks) {
        if (network.attributes) network.attributes.show = false;
      }

      return activeBlock.children
        .concat(unusedNetworks)
        .filter((item) => !!item);
    },
  },
});
